export default __webpack_public_path__ + "0cceac228a562356b615f4ea51b5e1ad.png";